type Predicate<T> = (value: T[keyof T], key: keyof T) => boolean;

export function pickBy<T>(object: T, predicate: Predicate<T>): Partial<T> {
  const result: Partial<T> = {};

  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      const value = object[key];
      if (predicate(value, key)) {
        result[key] = value;
      }
    }
  }

  return result;
}
